import React from 'react';
import { Grid } from 'fw/forms';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import SearchQueueLinkByPersonAndQueue from 'areas/shared/components/formatter/SearchQueueLinkByPersonAndQueue';

const columns = [
	{ key: 'userName', name: 'APPs by Person', width: 120, sortable: false },
	{ key: 'appReviewCount', name: 'AR', formatter: SearchQueueLinkByPersonAndQueue, getRowMetaData: (row) => [row, 'APP'], sortable: false },
	{ key: 'certReviewCount', name: 'CR', formatter: SearchQueueLinkByPersonAndQueue, getRowMetaData: (row) => [row, 'CER'], sortable: false },
	{ key: 'commReviewCount', name: 'COM', formatter: SearchQueueLinkByPersonAndQueue, getRowMetaData: (row) => [row, 'COM'], sortable: false },
	{ key: 'siteReviewCount', name: 'VSA', formatter: SearchQueueLinkByPersonAndQueue, getRowMetaData: (row) => [row, 'STR'], sortable: false },
	{ key: 'pendingDenialCount', name: 'PD', formatter: SearchQueueLinkByPersonAndQueue, getRowMetaData: (row) => [row, 'PD'], sortable: false },
	{ key: 'totalCount', name: 'Total', formatter: SearchQueueLinkByPersonAndQueue, getRowMetaData: (row) => [row, null], sortable: false }
];

class ApplicationsByPerson extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
			list: []
		};
	}

	componentDidMount() {
		this.handleSearch();
	}

	handleSearch = (filters, callback) => {
		this.setState({
			list: []
		}, function () {
			this.search(null, callback);
		});
	}

	search = (opts, callback) => {
		const rq = Object.assign({}
		);

		var state = {
			list: []
		};

		new API().post(APIModules.Admin.url('/dashboard/getApplicationsByPerson'), rq,
			{
				success: (r) => {
					const items = r.data.items || [];

					// Calculate totals row
					const totalsRow = {
						userId: 0,
						userName: 'TOTALS',
						appReviewCount: items.reduce((sum, item) => sum + item.appReviewCount, 0),
						certReviewCount: items.reduce((sum, item) => sum + item.certReviewCount, 0),
						commReviewCount: items.reduce((sum, item) => sum + item.commReviewCount, 0),
						siteReviewCount: items.reduce((sum, item) => sum + item.siteReviewCount, 0),
						pendingDenialCount: items.reduce((sum, item) => sum + item.pendingDenialCount, 0),
						totalCount: items.reduce((sum, item) => sum + item.totalCount, 0)
					};

					state = {
						list: [...items, totalsRow]
					};

					// Store search results
					this.setState(state);

					// Callback
					if (callback)
						callback();
				}
			});

		return state;
	}

	render() {
		return (
			<React.Fragment>
				<div className="apps-by-person-grid">
					<Grid
						columns={columns}
						items={this.state.list}
						height={282}
						rowKey="userId"
						name="default" />
				</div>
				<table className="dashboard-print-table apps-by-person-print">
					<thead>
						<tr>
							<th>APPs by Person</th>
							<th>AR</th>
							<th>CR</th>
							<th>COM</th>
							<th>VSA</th>
							<th>PD</th>
							<th>Total</th>
						</tr>
					</thead>
					<tbody>
						{this.state.list.map((row, i) => (
							<tr key={i} className={row.userName === 'TOTALS' ? 'print-totals-row' : ''}>
								<td>{row.userName}</td>
								<td>{row.appReviewCount}</td>
								<td>{row.certReviewCount}</td>
								<td>{row.commReviewCount}</td>
								<td>{row.siteReviewCount}</td>
								<td>{row.pendingDenialCount}</td>
								<td>{row.totalCount}</td>
							</tr>
						))}
					</tbody>
				</table>
			</React.Fragment>
		)
	}
}

export default ApplicationsByPerson;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDashboard/applicationsByPerson/ApplicationsByPerson.js